import { apiSlice } from "../apiSlice";

export interface PromoCodeDta {
    discount: number;
    minTotalPrice: number;
    usageLimit: number;
    numberOfCoupons: number;
    validDays: number;
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export const restaurantSearchService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        generatePromoCode: builder.mutation<PromoCodeDta, any>({
            query: (data) => ({
                url: `https://superadminhttps-generatecouponcodes-${API_BASE_DOMAIN}-uc.a.run.app`,
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const {
    useGeneratePromoCodeMutation
} = restaurantSearchService;
